<template>
  <div id="about" class="section">
    <v-container>
      <h1>About Maria</h1>
      <v-layout row wrap>
        <v-flex xs12 sm3 pl-3>
          <a data-fancybox="gallery" data-type="image" href="/img/about/masha_teenager_large.png">
            <div class="img-thumbnail">
              <img src="/img/about/masha_teenager_thumb.png" alt="Образец работы" class="img-fluid">              
            </div>
          </a>
        </v-flex>
        <v-flex xs12 sm9 pl-3>
              <p class="text-justify">
                Born in her mother's home town in the Ukraine, Maria's earliest memories are of growing up in Kabul in Afghanistan, her father's country.</p>
              <p class="text-justify">
                She started painting and drawing at the age of 5, in Kabul, where she attended a highly inspiring studio set up by a Belorussian artist. These earliest artistic experiences might explain her own enthusiasm for teaching art to children, knowing the fruits that early tuition can bear.</p>
              <h1>Formal Art Education</h1>
              <p class="text-justify">
                Her own early inclination was eventually brought to fruition when the family moved to Moscow, and from the age of 11 she attended the Architectural Studio for Children, and Moscow Art School Number 1. Following this she attended the Academic Art College in Memory of 1905, where she met teachers and influences that largely shaped her artistic expression.</p>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm10 pl-3>
          <p class="text-justify">
            Maria's drawing teacher, Vladimir Pastukhov, was a well-known draftsman of the post-war social realist movement in Russia. The tradition he was coming from was very much based on the school of the old masters, such as Michelangelo, Rembrandt, Halls and Velasquez. Her painting teacher was Sergey Struchkov, and Maria recalls that he was a marvelous colorist. Both taught colour and composition based on good understanding of tone and drawing. The artists that influenced her perception and colour were Rembrandt, Velasquez, Degas, the impressionists, and also the great Russian portrait painter Valentin Serov and symbolist painters Mikhail Vrubel and Nikolai Ge. She was also influenced by theatre artist Konstantin Korovin, and Nikolai Feshin and his portraits and watercolours. Her training was thus relatively formal and academic, steeped in the world of 19th Century and ‘old master' academic techniques and models.
          </p>
          <p class="text-justify">
            The enviable skills thus assimilated and developed are clearly at Maria's fingertips. Assertive fluid brushstrokes and the underlying disciplines of proportion, composition, perspective, tone and colour are the hallmarks of this training. Her skills are evident where brilliant pure colour sings against a carefully managed muted tertiary palette. Free and spontaneous brushstrokes rest on a scaffold of understated structure.</p>
        </v-flex>
        <v-flex xs12 sm2 pl-2>
            <a data-fancybox="gallery" data-type="image" href="/img/about/mashanakryshe_large.png">
                <div class="img-thumbnail">
                  <img src="/img/about/mashanakryshe_thumb.png" alt="Образец работы" class="img-fluid">              
                </div>
              </a>
        </v-flex>
      </v-layout>  
      <v-layout row wrap>
        <v-flex xs12 pl-3>
          <h1>Media</h1>
            <p class="text-justify">
              Maria employs a variety of media: oil, watercolour and various drawing media. Again, the grounding in technique allows for freedom to choose and manipulate the medium best suited to a given subject, and the regular use of all these media seem to stimulate her artistic sensibility.</p>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm3 pl-3>
              <a data-fancybox="gallery" data-type="image" href="/img/about/masha_work_large.png">
                <div class="img-thumbnail">
                  <img src="/img/about/masha_work_thumb2.png" alt="Образец работы" class="img-fluid">              
                </div>
              </a>
        </v-flex>
        <v-flex xs12 sm9 pl-3>
          <h1>Subjects</h1>
          <p class="text-justify">
              Maria says, "I am naturally attracted to a great variety of subjects, finding inspiration in the faces and figures of people, in grays and tertiary coloured landscapes and cityscapes, in the terracotta roofs and azure seas of the south, and especially in everything related to dance and music making."</p>       
          <p class="text-justify">
              In landscapes, seascapes and cityscapes Maria demonstrates her lively sense of colour and composition, accented by detail and texture. While her inner world, developed through her deep spiritual commitment to her Russian Orthodox faith, seems to lend depth and to imbue her portraits, figure studies, interiors and still life subjects with something beyond the purely visual representation.</p>
           <p class="text-justify">
              Perhaps, the subjects closest to Maria's heart are those related to dance and music. Herself a semi-professional singer, music and dance have been particular inspirations throughout her career. Perhaps here it is best to let Maria describe this in her own words:</p>     
        </v-flex>
      </v-layout>       
      <v-layout row wrap>
        <v-flex xs12 pl-3>
                  
          <p class="text-justify mt-3">
              "I developed as a child an interest in the art forms of dance and music, and between 1995-1997 spent almost 2 years at the Bolshoj Theatre in Moscow drawing dancers and painting my final piece. Classical and contemporary dance inspires my drawing and painting because in it one finds a combination of the athletic, aesthetic, musical and coloristic, all in one. I particularly enjoyed looking beyond the outer appearances and movements of the dancers, and tried to capture something of their characters and aspirations".</p>   
          <p class="text-justify">
              "Even though I spend a lot of time drawing and painting inanimate objects, like still-life or landscape, my passion is really in painting people, and capturing and expressing something of their inner world."</p>
            <v-layout>
                <v-spacer></v-spacer>
                <p><cite>by Jennifer Spohn</cite></p>             
            </v-layout>
        </v-flex>  
      </v-layout> 
    </v-container>
  </div>
</template>

<script>
  export default {
    name: 'About',
      data: ()=>({

      })
  }
</script>


<style>
  #about .img-left {
    float: left;
    padding: 0 5px;
    border-right: 1px solid #232323;
    border-bottom: 1px solid #232323;
    margin-right: 15px;
  }

  #about .img-right {
    float: right;
    padding: 0 5px;
    border-left: 1px solid #232323;
    border-bottom: 1px solid #232323;
    margin-left: 15px;
  }
  #about .img-thumbnail {
    padding: 5px;
    border: 1px solid #ccc;
    float: left;
    border-radius: 5px;
  }
</style>